export const T = {
  en_GB: { noData: "No valid data to display" },
  nb_NO: { noData: "Ingen gyldige data å vise" },
} as const;
